import $ from 'jquery';
import _ from 'underscore';
import { FilterEntity } from '@bingads-webui/filter-entity';

export const getBulkEditParams = ({ state }) => {
  if (!state) {
    return {};
  }
  const getDateRange = () => {
    try {
      const dateRange = state.get('$daterange');
      const startdate = (dateRange.start || dateRange.RangeStartDate).toISOString();
      const enddate = (dateRange.end || dateRange.RangeEndDate).toISOString();

      return `startdate=${startdate}&enddate=${enddate}`;
    } catch (e) {
      return '';
    }
  };

  const mergeStrFilter = (str1, str2) => {
    if (_.isEmpty(str1)) {
      return str2;
    }
    if (_.isEmpty(str2)) {
      return str1;
    }
    return [str1, str2].join(' and ');
  };

  const getQueryString = ({
    selectionCount,
    selectedIds,
    idAttribute,
    filter,
    customStrFilter,
    isPreview,
  }) => {
    const queryArray = [];
    let strFilter = '';

    // When preview, select ids on current page only.
    // selectionCount === selectedIds.length indicates cross page select all not checked
    if (isPreview || selectionCount <= selectedIds.length) {
      strFilter = _.chain(selectedIds)
        .map(id => `${idAttribute} eq '${id}'`)
        .join(' or ')
        .value();
    } else if (filter) {
      strFilter = new FilterEntity(filter.query, {
        entitySchema: _.result(filter, 'options.entitySchema'),
        odata: _.omit(filter.options, 'entitySchema'),
      }).odataV4();
    }
    strFilter = mergeStrFilter(strFilter, customStrFilter);
    if (!_.isEmpty(strFilter)) {
      strFilter = $.param({ $filter: `(${strFilter})` });
    }
    queryArray.push(strFilter);
    queryArray.push(getDateRange());

    return _.chain(queryArray)
      .compact()
      .join('&')
      .value();
  };


  const getDescription = (selectionCount) => {
    const description = {
      idsCount: selectionCount,
    };

    return JSON.stringify(description);
  };

  const bulkEditParams = ({
    selectionCount,
    selectedIds,
    idAttribute = 'Id',
    filter,
    customStrFilter,
    batchActions,
    entity,
    campaignId = null,
    adgroupId = null,
    isPreview,
  }) => ({
    BatchAction: batchActions,
    Description: getDescription(selectionCount),
    Entity: entity,
    Selection: {
      QueryString: getQueryString({
        selectionCount,
        selectedIds,
        idAttribute,
        filter,
        customStrFilter,
        isPreview,
      }),
      CampaignId: campaignId,
      AdGroupId: adgroupId,
    },
  });

  return {
    bulkEditParams,
  };
};
